import { Box, Card, Stack, Typography } from "@mui/material";
import { ConfigProvider, DatePicker, Form, Select, Button, Table } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { getData, postData } from "../utils/lccmServices";
import { notiError } from "../utils/notiUltils";
import dayjs from "dayjs";
import { blue } from "@mui/material/colors";
import ExportTable2 from "../components/ExportTable2";
//import "dayjs/locale/th";
//dayjs.locale("th");

function Speed() {
  const [masterLoading, setMasterLoading] = useState(true);
  //const [categoriesData, setCategoriesData] = useState([]);
  //const [alarmData, setAlarmData] = useState([]);
  const [vehicleData, setVehicleData] = useState([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const onFinish = async (values) => {
    if (values.dateEnd.diff(values.dateStart, "second") < 0) {
      notiError({ message: "ระบุช่วงเวลาไม่ถูกต้อง !", position: "center" });
      return;
    }
    setDataSource([]);
    setReportLoading(true);
    const params = {
      alarms: values.alarms,
      categories: values.categories,
      vehicles: values.vehicles,
      dateStart: values.dateStart.startOf("date").format("YYYY-MM-DD HH:mm:ss"),
      dateEnd: values.dateEnd.endOf("date").format("YYYY-MM-DD HH:mm:ss"),
    };
    //console.log(params);

    try {
      const data = await postData("/reportSpeeds", true, params);
      //console.log(data);
      setDataSource(data);
      setDateStart(values.dateStart);
      setDateEnd(values.dateEnd);
    } catch (err) {
      console.error(err);
      notiError({ message: err, position: "center" });
    }

    setReportLoading(false);
  };

  useEffect(() => {
    async function fecthCategories() {
      try {
        const data = await getData("/masterForReportAlarm", true);
        /*setCategoriesData(
          data.categories.map((a) => {
            return { value: a.CategoryID, label: a.CategoryName };
          })
        );
        setAlarmData(
          data.alarms.map((a) => {
            return { value: a.AlarmID, label: a.AlarmName };
          })
        );*/
        setVehicleData(
          data.vehicles.map((a) => {
            return { value: a.VehicleID, label: a.VehicleName };
          })
        );
        setMasterLoading(false);
      } catch (err) {
        console.error(err);
        notiError({ message: err, position: "center" });
      }
    }
    fecthCategories();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "kanit",
          //colorBgContainer: "transparent",
        },
      }}
    >
      <Card
        elevation={0}
        variant="outlined"
        sx={{ bgcolor: blue[100], mt: 1.5 }}
      >
        <Box sx={{ p: 2 }}>
          <Form disabled={reportLoading} onFinish={onFinish} autoComplete="off">
            <Stack direction={"row"} spacing={2}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: (
                      <Typography
                        variant="caption"
                        sx={{ fontStyle: "italic" }}
                      >
                        โปรดระบุวันที่เริ่มต้น
                      </Typography>
                    ),
                  },
                ]}
                name="dateStart"
                style={{ flexGrow: 1, maxWidth: 200 }}
              >
                <DatePicker
                  size="large"
                  placeholder="จากวันที่"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: (
                      <Typography
                        variant="caption"
                        sx={{ fontStyle: "italic" }}
                      >
                        โปรดระบุวันที่สิ้นสุด
                      </Typography>
                    ),
                  },
                ]}
                name="dateEnd"
                style={{ flexGrow: 1, maxWidth: 200 }}
              >
                <DatePicker
                  size="large"
                  placeholder="ถึงวันที่"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              {/* <Form.Item
                name="categories"
                style={{ flexGrow: 1, minWidth: 100 }}
              >
                <Select
                  loading={masterLoading}
                  options={categoriesData}
                  placeholder="หมวดหมู่"
                  size="large"
                  allowClear
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                />
              </Form.Item> */}
              {/* <Form.Item name="alarms" style={{ flexGrow: 1, minWidth: 100 }}>
                <Select
                  placeholder="การแจ้งเตือน"
                  size="large"
                  loading={masterLoading}
                  options={alarmData}
                  allowClear
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                />
              </Form.Item> */}
              <Form.Item name="vehicles" style={{ flexGrow: 1, minWidth: 100 }}>
                <Select
                  placeholder="ทะเบียน"
                  size="large"
                  loading={masterLoading}
                  options={vehicleData}
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                  allowClear
                  optionFilterProp="label"
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item style={{ flexGrow: 1, maxWidth: 120 }}>
                <Button
                  style={{ width: "100%" }}
                  size="large"
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                  loading={reportLoading}
                >
                  ค้นหา
                </Button>
              </Form.Item>
            </Stack>
          </Form>
        </Box>
      </Card>

      <Card
        elevation={0}
        variant="outlined"
        sx={{ bgcolor: blue[100], mt: 1.5 }}
      >
        <Box sx={{ p: 2 }}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Typography mb={2} variant="subtitle2" fontWeight={700}>
              ตารางแสดงข้อมูลความเร็วเกินกำหนด
            </Typography>
            <Box mt={-0.5}>
              <ExportTable2
                data={dataSource}
                fileName="speed_"
                reportName="ตารางแสดงข้อมูลความเร็วเกินกำหนด"
                columns={[
                  { title: "สถานที่", dataIndex: "LocationName" },
                  { title: "ความเร็วที่จำกัด", dataIndex: "SpeedLimit" },
                  { title: "ละติจูด", dataIndex: "Latitude" },
                  { title: "ลองจิจูด", dataIndex: "Longitude" },
                  { title: "จำนวนครั้ง", dataIndex: "Amount" },
                ]}
                column2={[
                  { title: "วันที่ - เวลา", dataIndex: "Datetime" },
                  { title: "ทะเบียน", dataIndex: "VehicleName" },
                  { title: "ความเร็ว", dataIndex: "Speed" },
                  { title: "การแจ้งเตือน", dataIndex: "AlarmName" },
                  { title: "ละติจูด", dataIndex: "Latitude" },
                  { title: "ลองจิจูด", dataIndex: "Longitude" },
                ]}
                timeRange={{ dateStart, dateEnd }}
              />
            </Box>
          </Box>

          <TableData loading={reportLoading} dataSource={dataSource} />
        </Box>
      </Card>
    </ConfigProvider>
  );
}

export default Speed;

const expandedRowRender = (record) => {
  return (
    <Table
      size="small"
      //bordered
      columns={[
        {
          title: "ลำดับ",
          render: (a) => a.index,
          align: "center",
          width: "5%",
        },
        {
          title: "วันที่ - เวลา",
          sorter: (a, b) => (a.GpsDatetime > b.GpsDatetime ? 1 : -1),
          sortDirections: ["descend"],
          render: (a) =>
            dayjs(a.GpsDatetime).utc().format("YYYY-MM-DD HH:mm:ss"),
          showSorterTooltip: false,
        },
        {
          title: "ทะเบียน",
          dataIndex: "VehicleName",
          sorter: (a, b) => (a.VehicleName > b.VehicleName ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "ความเร็ว",
          dataIndex: "Speed",
          align: "center",
          sorter: (a, b) => (a.Speed > b.Speed ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "การแจ้งเตือน",
          dataIndex: "AlarmName",
          sorter: (a, b) => (a.AlarmName > b.AlarmName ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "ละติจูด",
          dataIndex: "Latitude",
          sorter: (a, b) => (a.Latitude > b.Latitude ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "ลองจิจูด",
          dataIndex: "Longitude",
          sorter: (a, b) => (a.Longitude > b.Longitude ? 1 : -1),
          showSorterTooltip: false,
        },
      ]}
      dataSource={record.dataSource}
      pagination={{ pageSize: 5, showSizeChanger: false }}
    />
  );
};

function TableData({ loading, dataSource }) {
  return (
    <Table
      bordered
      loading={loading}
      size="small"
      expandable={{ expandedRowRender }}
      columns={[
        {
          title: "ลำดับ",
          render: (a) => parseInt(a.key) + 1,
          align: "center",
          width: "5%",
        },
        {
          title: "สถานที่",
          dataIndex: "LocationName",
          //width:'20%',
          sorter: (a, b) => (a.LocationName > b.LocationName ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "ความเร็วที่จำกัด",
          dataIndex: "SpeedLimit",
          align: "center",
          sorter: (a, b) => (a.SpeedLimit > b.SpeedLimit ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "ละติจูด",
          dataIndex: "Latitude",
          sorter: (a, b) => (a.Latitude > b.Latitude ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "ลองจิจูด",
          dataIndex: "Longitude",
          sorter: (a, b) => (a.Longitude > b.Longitude ? 1 : -1),
          showSorterTooltip: false,
        },
        {
          title: "จำนวน",
          dataIndex: "Amount",
          align: "right",
          sorter: (a, b) => (a.Amount > b.Amount ? 1 : -1),
          showSorterTooltip: false,
        },
      ]}
      dataSource={dataSource}
      //pagination={{ pageSize: 20, showSizeChanger: false }}
      pagination={{
        showSizeChanger: true,
        defaultPageSize: 20,
        pageSizeOptions: ["20", "50", "100"],
      }}
      scroll={{ y: `calc(100vh - 480px)` }}
    />
  );
}
